import {withKnownRoute} from '../../lib/routes';
import {ToolsPage} from './tools-page';

export default withKnownRoute(ToolsPage);
